import { render } from "./OpenProjectsComponent.vue?vue&type=template&id=569a2e9d&scoped=true"
import script from "./OpenProjectsComponent.vue?vue&type=script&lang=js"
export * from "./OpenProjectsComponent.vue?vue&type=script&lang=js"

import "./OpenProjectsComponent.vue?vue&type=style&index=0&id=569a2e9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569a2e9d"]])

export default __exports__